import * as React from 'react';
import { createPortal, findDOMNode } from 'react-dom';
import { Menu, Dropdown } from 'antd';
import ClickAwayListener from '../click-away-listener';

export interface IMenu {
  name: string;
  value?: string;
  children?: IMenu[];
}

export interface IStupidDropdownMenuProps {
  visible: boolean;
  menus: IMenu[];
  position: { left: number, top: number };
  close: () => void;
  insert: (value: string) => void;
}



class StupidDropdownMenu extends React.Component<IStupidDropdownMenuProps>{
  private node: HTMLDivElement | null = null;

  private dropdownMenuRef: React.RefObject<Menu> = React.createRef();

  public componentWillMount() {
    this.node = document.createElement('div');
    document.body.appendChild(this.node);
  }

  public componentWillUnmount() {
    document.body.removeChild(this.node!);
    this.node = null;
  }

  private getHostNode = () => {
    if (!this.dropdownMenuRef.current) { return null; }

    return findDOMNode(this.dropdownMenuRef.current);
  }


  private insertNodeValue = (v?: string) => {
    const { insert } = this.props;
    if (v) {
      insert(v);
    }
  }

  private generateMenu() {
    const { menus } = this.props;

    const createNestMenus = (items: IMenu[]) => {
      return items.map(menu => {
        const key = menu.value || menu.name;
        if (menu.children) {
          return (
            <Menu.SubMenu key={key} title={menu.name}>
              {createNestMenus(menu.children)}
            </Menu.SubMenu>
          );
        } else {
          return (
            <Menu.Item key={key} onClick={() => this.insertNodeValue(menu.value)}>
              {menu.name}
            </Menu.Item>
          );
        }
      });
    };

    return (<Menu ref={this.dropdownMenuRef}>{createNestMenus(menus)}</Menu>);
  }

  public render() {
    const { visible, position } = this.props;
    const { left, top } = position;
    const styles: any = {
      left, top,
      width: 0, height: 0, padding: 0,
      position: 'absolute', border: 'none'
    };

    return createPortal(
      <ClickAwayListener
        onClickAway={() => this.props.close()}
        getChildNode={this.getHostNode}
      >
        <Dropdown
          visible={visible}
          overlay={this.generateMenu()}
        >
          <span style={styles}></span>
        </Dropdown>
      </ClickAwayListener>,
      this.node!
    );
  }
}

export default StupidDropdownMenu;
